import { defineComponent as _defineComponent } from 'vue'
import { useApi } from "@/plugins/api/api";
import { ref, computed, watch, onMounted } from "vue";

type Item = { text: string; value: string };

type Props = {
  value?: string;
  init?: boolean;
};
type Emits = {
  (e: "input", val?: string): void;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'AuthoritySelect',
  props: {
    value: null,
    init: { type: Boolean }
  },
  emits: ["input"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: "input", val?: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  value?: string;
  init?: boolean;
};

const { $code } = useApi();




const modelValue = computed({
  get: () => props.value,
  set: val => emits("input", val)
});

const items = ref<Item[]>([]);

const getItems = async () => {
  const result = await $code("AUTH");
  if (result) {
    items.value = result
      .filter(e => e.code !== "9")
      .map(e => ({ value: e.code, text: e.name }));
  }
};

watch(items, val => {
  const firstItem = val[0]?.value;
  if (firstItem && !modelValue.value && props.init)
    modelValue.value = firstItem;
});

onMounted(async () => {
  await getItems();
});

return { __sfc: true,$code, props, emits, modelValue, items, getItems }
}

})